import { renderStore } from "../../../store/renderStore";

const ZERO_OFFSET = { x: 0, y: 0 } as const;

/**
 * Visual offset for a symbol while a 3D group drag is active.
 * Reads MobX observables so observer components re-render during drag
 * without committing sibling positions to the store each frame.
 */
export function getSymbol3DGroupTranslateOffset(symbolId: string): {
  x: number;
  y: number;
} {
  if (!renderStore.isObjectTranslating(symbolId)) {
    return ZERO_OFFSET;
  }
  return renderStore.groupTranslateOffset;
}
